import React, { useContext, useState } from 'react';
import { Container, ContainerBox, HeaderBox } from './styles';
import { Indicadores, RankingContext } from '@/context/ranking';
import { LayerSection } from '../../atoms/SelectorArea/LayerSection';
import { SwitchToggle } from '../../atoms/SelectorArea/SwitchToggle';
import { useIndicators } from '@/hooks';


export const SelectorArea: React.FC = () => {
  const [cntGneral, setCntGneral] = useState(true)
  const [cntCapHum, setCapHum] = useState(false)
  const [cntDesEco, setDesEco] = useState(false)
  const [cntDesSoci, setDesSoci] = useState(false)
  const [cntCondVida, setCondVida] = useState(false)
  const [cntEduca, setEduca] = useState(false)
  const [cntInfra, setInfra] = useState(false)
  const [cntInsti, setInsti] = useState(false)
  const [cntJuventude, setJuventude] = useState(false)
  const [cntSaude, setSaude] = useState(false)
  const [cntSeg, setSeg] = useState(false)
  const { setAreaCommitedItem } = useIndicators()

  const { setResearchArea } = useContext(RankingContext)

  return (
    <Container>
      <HeaderBox>
        <h3>Ranking geral</h3>
        <SwitchToggle white color="#003886" onChange={() => {
          setDesEco(false)
          setCondVida(false)
          setCapHum(false)
          setCntGneral(true)
          setDesSoci(false)
          setEduca(false)
          setInfra(false)
          setInsti(false)
          setJuventude(false)
          setSaude(false)
          setSeg(false)
          setResearchArea("Geral")
        }} isCheck={cntGneral} actionElse={() => {
          setResearchArea("Geral")
        }} />
      </HeaderBox>
      <ContainerBox>
        <p>Navegue pelo ranking das áreas:</p>
        <LayerSection  name='capital_humano' >
          <SwitchToggle color={Indicadores['capital_humano'].color} onChange={() => {
            setCapHum(true)
            setCntGneral(false)
            setDesEco(false)
            setDesSoci(false)
            setCondVida(false)
            setEduca(false)
            setInfra(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("capital_humano")
            setAreaCommitedItem("capital_humano")
          }} isCheck={cntCapHum} actionElse={() => {
            setCntGneral(true)
            setCapHum(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='condicoes_de_vida' >
          <SwitchToggle color={Indicadores['condicoes_de_vida'].color} onChange={() => {
            setCondVida(true)
            setCapHum(false)
            setCntGneral(false)
            setDesEco(false)
            setDesSoci(false)
            setEduca(false)
            setInfra(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("condicoes_de_vida")
            setAreaCommitedItem("condicoes_de_vida")
          }} isCheck={cntCondVida} actionElse={() => {
            setCntGneral(true)
            setCondVida(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='desenvolvimento_economico' >
          <SwitchToggle color={Indicadores['desenvolvimento_economico'].color} onChange={() => {
            setDesEco(true)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setDesSoci(false)
            setEduca(false)
            setInfra(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("desenvolvimento_economico")
            setAreaCommitedItem("desenvolvimento_economico")
          }} isCheck={cntDesEco} actionElse={() => {
            setCntGneral(true)
            setDesEco(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='desenvolvimento_social' >
          <SwitchToggle color={Indicadores['desenvolvimento_social'].color} onChange={() => {
            setDesSoci(true)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setEduca(false)
            setInfra(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("desenvolvimento_social")
            setAreaCommitedItem("desenvolvimento_social")
          }} isCheck={cntDesSoci} actionElse={() => {
            setCntGneral(true)
            setDesSoci(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='educacao' >
          <SwitchToggle color={Indicadores['educacao'].color} onChange={() => {
            setEduca(true)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setInfra(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("educacao")
            setAreaCommitedItem("educacao")
          }} isCheck={cntEduca} actionElse={() => {
            setCntGneral(true)
            setEduca(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='infraestrutura' >
          <SwitchToggle color={Indicadores['infraestrutura'].color} onChange={() => {
            setInfra(true)
            setEduca(false)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setInsti(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("infraestrutura")
            setAreaCommitedItem("infraestrutura")

          }} isCheck={cntInfra} actionElse={() => {
            setCntGneral(true)
            setInfra(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='institucional' >
          <SwitchToggle color={Indicadores['institucional'].color} onChange={() => {
            setInsti(true)
            setInfra(false)
            setEduca(false)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setJuventude(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("institucional")
            setAreaCommitedItem("institucional")


          }} isCheck={cntInsti} actionElse={() => {
            setCntGneral(true)
            setInsti(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='juventude' >
          <SwitchToggle color={Indicadores['juventude'].color} onChange={() => {
            setJuventude(true)
            setInsti(false)
            setInfra(false)
            setEduca(false)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setSaude(false)
            setSeg(false)
            setResearchArea("juventude")
            setAreaCommitedItem("juventude")

          }} isCheck={cntJuventude} actionElse={() => {
            setCntGneral(true)
            setJuventude(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='saude' >
          <SwitchToggle color={Indicadores['saude'].color} onChange={() => {
            setSaude(true)
            setJuventude(false)
            setInsti(false)
            setInfra(false)
            setEduca(false)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setSeg(false)
            setResearchArea("saude")
            setAreaCommitedItem("saude")

          }} isCheck={cntSaude} actionElse={() => {
            setCntGneral(true)
            setSaude(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
        <LayerSection name='seguranca' >
          <SwitchToggle color={Indicadores['seguranca'].color} onChange={() => {
            setSeg(true)
            setSaude(false)
            setJuventude(false)
            setInsti(false)
            setInfra(false)
            setEduca(false)
            setDesSoci(false)
            setDesEco(false)
            setCondVida(false)
            setCapHum(false)
            setCntGneral(false)
            setResearchArea("seguranca")
            setAreaCommitedItem("seguranca")
          }} isCheck={cntSeg} actionElse={() => {
            setCntGneral(true)
            setSeg(false)
            setResearchArea("Geral")
          }} />
        </LayerSection>
      </ContainerBox>
    </Container>
  )
};
